export class PopupWindow {

	public static addUrlParam(url:string, name:string, value:string) : string {
		let separator = url.indexOf("?") > 0 ? "&" : "?";
		return url + separator + name + "=" + encodeURIComponent(value);
	}

	public static show(url: string) : Promise<void> {
		
		return new Promise<void>((resolve, reject) => {
			let w = Math.min(window.screen.width, 900);
			let h = Math.min(window.screen.height, 900);
	
			var x = (window.screen.width/2)-(w/2);
			var y = (window.screen.height/2)-(h/2);

			let isSharePointUrl = url.indexOf("Form.aspx") > 0;

			if(isSharePointUrl) {
				
				url = PopupWindow.addUrlParam(url, "Source", window.location.href);
				url = PopupWindow.addUrlParam(url, "HelmUX", "1");

				//We now have to re-encode this URL to do a redirect to it, since we can't get a handle to the window if it is opened directly.
				url = `${window.location.origin}/#redirect/${encodeURIComponent(url)}`;
			}
	
			let win = window.open(url, 'helmPopup', `toolbar=no, location=no, directories=no, status=yes, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
	
			if(!win){
				win = window.open(url, '_blank');
			}

			//Don't start the popup close checks for 1 second, to give the popup time to load and redirect if needed.
			setTimeout(() => {
				let interval = setInterval(() => {
					if (!win || win.closed) {
						clearInterval(interval);
						resolve();
					} else {
						try {

							if (isSharePointUrl && 
								win.location.href.indexOf('about:blank') < 0 && 
								win.location.href.indexOf('Form.aspx') < 0 && 
								(win.location.hash || '').indexOf('#redirect') < 0) {

								console.log(win.location);
								win.close();
								clearInterval(interval);
								resolve();
							}
						} catch {
							// The window may be currently at microsoftonline.com or somewhere else where a cross-origin location check won't work.
						}
					}
				}, 100);
			}, 1000);
		});
	}
	
}